// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__12-rh","logo":"style_logo__2gF4N","item":"style_item__1Eitn","bold":"style_bold__ZuEKl"};